// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import Enums from '../Enums';

export class DispatchActualsSyncInfo {
  readonly status: Enums.DispatchActualsImportStatus;
  readonly lastJobCreatedAt: DateTime;
  readonly syncedAt: DateTime | null;

  constructor(data: { [key: string]: any } = {}) {
    this.status = data.status === undefined ? Enums.DispatchActualsImportStatus.Ok : data.status;
    this.lastJobCreatedAt = DateHelpers.ParseServerDateTime(data.lastJobCreatedAt);
    this.syncedAt = DateHelpers.ParseServerNullableDate(data.syncedAt);
  }

  static zero(): DispatchActualsSyncInfo {
    const zeroValues: ExcludeMethodsDeep<DispatchActualsSyncInfo> = {
      status: Enums.DispatchActualsImportStatus.Ok,
      lastJobCreatedAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
      syncedAt: null,
    };
    return new DispatchActualsSyncInfo(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type DispatchActualsSyncInfoWireFormat = {
  status: string;
  lastJobCreatedAt: string;
  syncedAt: string | null;
};

type NewDispatchActualsSyncInfoProps = PartialDeep<
  DispatchActualsSyncInfo,
  { recurseIntoArrays: true }
>;
export const NewDispatchActualsSyncInfo: (
  props: NewDispatchActualsSyncInfoProps,
) => DispatchActualsSyncInfo = (props) => new DispatchActualsSyncInfo(props);

type NewDispatchActualsSyncInfoFromWireFormatProps = PartialDeep<
  DispatchActualsSyncInfoWireFormat,
  { recurseIntoArrays: true }
>;
export const NewDispatchActualsSyncInfoFromWireFormat: (
  props: NewDispatchActualsSyncInfoFromWireFormatProps,
) => DispatchActualsSyncInfo = (props) => new DispatchActualsSyncInfo(props);
